<template>
    <div v-if="attachment"
         class="card shadow-sm rounded bg-white position-relative attachment-card">
        <div class="image-wrapper" @click="$emit('open-image', attachment)">
            <img class="img-fluid rounded w-100 h-100"
                 :src="attachment.attachment"
                 alt="attachment"
                 style="object-fit: cover;"/>
            <div class="image-overlay">
                <b-icon-zoom-in class="overlay-icon"></b-icon-zoom-in>
            </div>
        </div>
        <p v-if="attachment.description || attachment.is_before || attachment.is_after"
           class="mb-0 text-muted text-center position-absolute w-100 attachment-description"
        >{{ label }}</p>
    </div>
    <div v-else class="attachment-gap"></div>
</template>

<script>
export default {
    name: 'AttachmentCard',
    props: {
        attachment: {
            type: Object,
            default: null
        }
    },
    computed: {
        label() {
            if (!this.attachment) return '';
            const prefix = this.attachment.is_before ? 'Image Before. '
                         : this.attachment.is_after  ? 'Image After. '
                         : '';
            return prefix + (this.attachment.description || '');
        }
    }
}
</script>

<style scoped>
.attachment-card {
    position: relative;
    width: 100%;
    max-width: 300px;
}

.attachment-gap {
    width: 100%;
    max-width: 300px;
    height: 100%;
    align-self: stretch;
    position: relative;
    background: repeating-linear-gradient(
        45deg,
        #f0f0f0,
        #f0f0f0 6px,
        #fafafa 6px,
        #fafafa 12px
    );
    border-radius: 0.25rem;
    opacity: 0.6;
}

.image-wrapper {
    position: relative;
    width: 100%;
    max-width: 300px;
    overflow: hidden;
    cursor: pointer;
}

.image-wrapper img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.image-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0;
    transition: opacity 0.2s;
}

.image-wrapper:hover .image-overlay {
    opacity: 1;
}

.attachment-description {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 0.25rem;
    background: rgba(255, 255, 255, 0.7);
    text-align: center;
}
</style>
